/**
 * Reglas de acceso al panel de Seguridad (`/security/*`) para usuarios sin
 * ROLE_ADMIN pero con permiso granular concedido (module:action, ver
 * `user.permissions` — poblado en el login vía `getMyPermissions()`).
 * Compartido entre el guard del router y el menú lateral para no duplicar
 * la lógica en dos sitios.
 */

const hasRole = (roles, role) => Array.isArray(roles) && roles.includes(role);

export const hasRoleAdmin = (roles) => hasRole(roles, "ROLE_ADMIN");

export const hasRoleSuperAdmin = (roles) => hasRole(roles, "ROLE_SUPER_ADMIN");

const hasAnyPermissionPrefix = (permissions, prefix) =>
  Array.isArray(permissions) && permissions.some((permission) => permission.startsWith(prefix));

const hasPermission = (permissions, permission) =>
  Array.isArray(permissions) && permissions.includes(permission);

export const canAccessSecurityPermissions = (roles, permissions) =>
  hasRoleAdmin(roles) || hasAnyPermissionPrefix(permissions, "security_permissions:");

export const canAccessSecurityApiApplications = (roles, permissions) =>
  hasRoleAdmin(roles) || hasAnyPermissionPrefix(permissions, "api_keys:");

export const canAccessSecurityAudit = (roles, permissions) =>
  hasRoleAdmin(roles) || hasPermission(permissions, "audit:view");

export const canAccessImpersonations = (roles, permissions) =>
  hasRoleSuperAdmin(roles) || hasPermission(permissions, "impersonation:execute");

export const canAccessSecurityDashboard = (roles, permissions) =>
  canAccessSecurityPermissions(roles, permissions) ||
  canAccessSecurityApiApplications(roles, permissions) ||
  canAccessSecurityAudit(roles, permissions) ||
  canAccessImpersonations(roles, permissions);

